import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant?.js'
import axios from 'axios'
import Moment from 'react-moment'
import moment from 'moment'
import { getCountryTimeZone, getCurrency, getImage, getVat } from '../../Constant.js'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import { WaveLoading } from 'react-loadingg'

import 'react-responsive-modal/styles.css'
import { Modal } from 'react-responsive-modal'
import EditCruiseModel from './editCruise.js'
import RefundModel from './Refund.js'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
import { Link } from 'react-router-dom'
import SendPayment from './SendPayment.js'
import ComplaintModel from './Complaint.js'
import ComplaintActionModel from './ComplaintAction.js'
import { base64ToImageDownload, base64ToPdfDownload } from '../../common/Utils.js'
import Button from '../../common/CustomComponents/Button.js'

const customModelStyles = {
  modal: {
    maxWidth: '1100px', // Set the maximum width
    minHeight: '200px',
    maxHeight: '90%',
    width: '100%', // Set the width
    padding: '20px', // Optional padding
    overflow: 'scroll',
  },
}
class Bookingdetail extends Component {
  state = {
    editBookingDetailsModel: false,
    sendPaymentModel: false,
    complaintModel: false,
    complaintActionModel: false,
    refundModel: false,
    refunded_amount: 0,

    bookingData: null,
    currency: getCurrency('KWT'),
    country: 'KWT',
    diwaniya_total_price: 0,
    waves_market_total_price: 0,
    store_total_price: 0,
    delivery_total_price: 0,
    car_booking_total: 0,
    total_Vat: 0,
    note: '',

    additional_hr: 0,
    additional_hr_price: 0,

    cruise_list: [],
    pickup_list: [],
    isLoading: false,

    // these keys are for download ticket for stores only
    shop_id: '',
    shop_type: '',
    shop_total_amount: '',
    shop_delivary_amount: '',
    shop_vat_amount: '',
    show_delivary: false,

    stores_booking: [],
    waves_market_booking: [],
    addons_bookings: [],
    ticket_type: '',
    selectedComplaintId: '',
  }

  style = {
    tableData: {
      padding: 5,
      paddingLeft: 10,
      border: '1px solid #ddd',
    },
    tableDataUnpaid: {
      background: '#f77',
      color: '#fff',
      fontWeight: 'bold',
    },
    tableDataPaid: {
      background: '#eee',
    },
  }

  componentDidMount() {
    this.getBookingDetails()
  }

  imageUrlToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl)
      const blob = await response.blob()

      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    } catch (error) {
      console.error('Error fetching or converting image:', error) // eslint-disable-line no-console
      return null
    }
  }

  getBookingDetails = async () => {
    await axios
      .get(Constant?.getAPI() + '/booking/booking-details/' + this.props?.match?.params?.booking_id, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState(
            {
              bookingData: res?.data?.data,
              currency: getCurrency(res?.data?.data?.country),
              country: res?.data?.data?.country,
            },
            async () => {
              let tempBookingDetails = this.state?.bookingData

              tempBookingDetails.slots.sort((a, b) => a?.slot_from?.localeCompare(b?.slot_from))
              tempBookingDetails.slots.sort((a, b) => a?.slot_date?.localeCompare(b?.slot_date))

              if (tempBookingDetails?.payment_details?.length > 0) {
                tempBookingDetails.payment_details.sort((a, b) => moment(a.created_at) - moment(b.created_at))
              }

              // let cruise_img_base64 = await this.imageUrlToBase64(tempBookingDetails?.cruise?.cruise_large_img);
              let cruise_img_base64 = await this.imageUrlToBase64(
                getImage() + tempBookingDetails?.cruise?.cruise_large_img
              )

              this.setState(
                {
                  bookingData: tempBookingDetails,
                  cruise_img_base64,
                },
                () => {
                  // set additional Hours
                  let destinationHours = this.state?.bookingData?.destination?.destination_min_hour?.slice(0, 2)
                  if (this.state?.bookingData?.slots.length > parseInt(destinationHours)) {
                    this.setState({
                      additional_hr: this.state?.bookingData?.slots.length - parseInt(destinationHours),
                    })
                  }
                  // diwaniya_items total
                  if (this.state?.bookingData?.diwaniya_items?.length > 0) {
                    let total = 0
                    let addons_bookings = []

                    this.state?.bookingData?.diwaniya_items?.forEach((element) => {
                      total = total + element.item_qty * element.amount
                      if (element.payment_status) {
                        let store_id = element?.cruise_diwaniya?.diwaniya_master?.store_id

                        if (
                          element?.cruise_diwaniya?.diwaniya_master?.store_id == '' ||
                          element?.cruise_diwaniya?.diwaniya_master?.store_id == 'undefined' ||
                          element?.cruise_diwaniya?.diwaniya_master?.store_id == null ||
                          element?.cruise_diwaniya?.diwaniya_master?.store_id == undefined
                        ) {
                          store_id = null
                        }

                        let existingItemIndex = addons_bookings.findIndex((itm) => itm.id == store_id)

                        if (existingItemIndex == -1) {
                          addons_bookings.push({
                            source: element?.cruise_diwaniya?.diwaniya_master?.source || 'OWNER',
                            id: store_id,
                            category:
                              store_id == null
                                ? 'OWNER'
                                : element?.cruise_diwaniya?.diwaniya_master?.wave_store?.shop_name_en || '--',
                          })
                        }
                      }
                    })

                    this.setState({
                      diwaniya_total_price: total,
                      addons_bookings: addons_bookings.filter(
                        (itm) => itm.category != 'OWNER' && itm.source != 'OWNER'
                      ),
                    })
                  }
                  // Waves Market Total
                  // Store Total
                  // Delivery charge Total
                  if (this.state?.bookingData?.additional_items?.length > 0) {
                    let waves_market_total_price = 0
                    let store_total_price = 0
                    let delivery_total_price = 0
                    let differ_store_ids = []

                    this.state?.bookingData?.additional_items?.forEach((element) => {
                      if (element?.store_item?.store?.shop_type == 'FOOD') {
                        waves_market_total_price = waves_market_total_price + element.item_qty * element.amount
                      } else if (element?.store_item?.store?.shop_type == 'STORE') {
                        store_total_price = store_total_price + element.item_qty * element.amount
                      }

                      if (!differ_store_ids.includes(element?.store_item?.store?.id)) {
                        differ_store_ids.push(element?.store_item?.store?.id)
                        delivery_total_price = delivery_total_price + element.delivery_charge
                      }
                    })

                    const car_booking_total = this.state.bookingData?.car_bookings?.reduce((acc, ele) => {
                      return acc + ele.total_amount
                    }, 0)

                    this.setState({
                      waves_market_total_price,
                      store_total_price,
                      delivery_total_price,
                      car_booking_total,
                      waves_market_booking: [
                        ...new Set(
                          this.state?.bookingData?.additional_items
                            .filter(
                              (item) => item?.payment_status == true && item?.store_item?.store?.shop_type == 'FOOD'
                            )
                            .map((item) =>
                              JSON.stringify({
                                id: item?.store_item?.store?.id,
                                category: item?.store_item?.store?.shop_name_en,
                              })
                            )
                        ),
                      ].map((item) => JSON.parse(item)),
                      stores_booking: [
                        ...new Set(
                          this.state?.bookingData?.additional_items
                            .filter(
                              (item) => item?.payment_status == true && item?.store_item?.store?.shop_type == 'STORE'
                            )
                            .map((item) =>
                              JSON.stringify({
                                id: item?.store_item?.store?.id,
                                category: item?.store_item?.store?.shop_name_en,
                              })
                            )
                        ),
                      ].map((item) => JSON.parse(item)),
                    })
                  }
                  // Calculate Vat
                  let vat = getVat(this.state?.country)
                  let vat_included_amount =
                    this.state?.bookingData?.total_booking_amount + this.state?.bookingData?.wallet_amount_applied

                  if (vat_included_amount > 0) {
                    this.setState({
                      total_Vat: vat_included_amount - vat_included_amount / (1 + vat / 100),
                    })
                  }

                  let refudedAmount = this.state.bookingData?.account_refund

                  if (this.state.bookingData?.customer?.wallet?.length > 0) {
                    refudedAmount += this.state.bookingData?.customer?.wallet?.reduce((acc, ele) => {
                      return acc + ele.amount
                    }, 0)
                  }

                  this.setState({
                    refunded_amount: refudedAmount,
                  })

                  this.getAvailableCruiseListForEdit()
                  this.getAvailablePickupListForEdit()
                  this.getAvailableDestinationListForEdit()
                }
              )
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getAvailableCruiseListForEdit = async () => {
    await axios
      .get(Constant?.getAPI() + `/booking/available-cruise`, {
        params: {
          cruise_master_id: this.state?.bookingData?.cruise?.cruise_master_id,
          booking_date: this.state?.bookingData?.booking_date,
          cruise_excepted: this.state?.bookingData?.cruise?.id,
          pickup_id: this.state?.bookingData?.pickup?.wave_pickup?.id || '',
          desti_id: this.state?.bookingData?.destination?.desti_id || '',
          destination_type: this.state?.bookingData?.destination?.book_by || '',
        },
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({ cruise_list: res.data.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getAvailablePickupListForEdit = async () => {
    await axios
      .get(Constant?.getAPI() + `/booking/available-pickup-points`, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({ pickup_list: res.data.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getAvailableDestinationListForEdit = async () => {
    await axios
      .get(Constant?.getAPI() + `/booking/get-destination-list/` + this.state?.bookingData?.cruise.id, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({ destination_list: res.data.data?.destinationList })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  changeBookingDetails = async (state) => {
    this.setState({
      editBookingDetailsModel: false,
      isLoading: true,
    })

    let data = {
      booking_id: this.state?.bookingData?.id,
    }

    if (state?.selected_cruise_id && state?.selected_cruise_id != this.state.bookingData.cruise.id) {
      data.new_cruise_id = state?.selected_cruise_id
    }

    if (state?.total_booking_amount && state?.total_booking_amount != this.state.bookingData.total_booking_amount) {
      data.total_booking_amount = state?.total_booking_amount
    }

    if (state?.type_tag && state?.type_tag != this.state.bookingData.type_tag) {
      data.type_tag = state?.type_tag
    }

    if (state?.destination_fee && state?.destination_fee != this.state.bookingData.destination_fee) {
      data.destination_fee = state?.destination_fee
    }

    if (state?.pick_up_id && state?.pick_up_id != this.state.bookingData.pick_up_id) {
      data.pick_up_id = state?.pick_up_id
    }

    if (state?.booking_status && state?.booking_status != this.state.bookingData.booking_status) {
      data.booking_status = state?.booking_status
    }

    if (this.state.bookingData.destination.book_by === 'day') {
      if (state?.destination_id && state?.destination_id != this.state.bookingData.destination_id) {
        data.destination_id = state?.destination_id
      }

      if (state?.bookingDateRange?.from && state?.bookingDateRange?.to) {
        data.booking_date = state?.bookingDateRange?.from
        data.booking_to_date = state?.bookingDateRange?.to
      }
    } else {
      if (state?.destination_id && state?.destination_id != this.state.bookingData.destination_id) {
        data.destination_id = state?.destination_id
        data.time_slots = state?.time_slots
      }

      if (state?.booking_date) {
        data.booking_date = state?.booking_date
        data.slot_start_from = state?.slot_start_from
        data.time_slots = state?.time_slots
      } else if (state?.slot_start_from && state?.slot_start_from != this.state.bookingData?.slots?.[0]?.slot_from) {
        data.slot_start_from = state?.slot_start_from
        data.time_slots = state?.time_slots
      }
    }

    await axios
      .post(Constant?.getAPI() + `/booking/change-booking-details`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire('Updated !', '', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.getBookingDetails()

        this.setState({
          isLoading: false,
        })
      })
  }

  showDetails = (type) => {
    switch (type) {
      case 'pickup':
        Swal.fire({
          width: '800px',
          title: '<strong>Pickup Details</strong>',
          html: `
            <table>
              <tbody>
                <tr>
                  <th>Address</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.pickup_address_en || '--'}</td></tr>
                <tr>
                  <th>Description</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.pickup_desc || '--'}</td></tr>
                <tr>
                  <th>Latitude</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.pickup_lat || '--'}</td></tr>
                <tr>
                  <th>Longitude</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.pickup_long || '--'}</td></tr>
                <tr>
                  <th>Map</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.pickup_map || '--'}</td></tr>
                <tr>
                  <th>Other Detail</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.pickup_other_detail || '--'}</td></tr>
                <tr>
                  <th>Vendor Name</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.wave_pickup?.vendor?.first_name} ${this.state?.bookingData?.pickup?.wave_pickup?.vendor?.last_name}</td></tr>
                <tr>
                  <th>Vendor Charge</th>
                  <td style="text-align: left">${this.state?.bookingData?.pickup?.wave_pickup?.pickup_vendor_charge || '--'}</td></tr>
              </tbody>
            </table>
          `,
        })
        break
      case 'destination':
        Swal.fire({
          width: '800px',
          title: '<strong>Destination Details</strong>',
          html: `
            <table>
              <tbody>
                <tr>
                  <th>Address</th>
                  <td style="text-align: left">${this.state?.bookingData?.destination?.destination_address_en || '--'}</td></tr>
                <tr>
                  <th>Latitude</th>
                  <td style="text-align: left">${this.state?.bookingData?.destination?.destination_lat || '--'}</td></tr>
                <tr>
                  <th>Longitude</th>
                  <td style="text-align: left">${this.state?.bookingData?.destination?.destination_long || '--'}</td></tr>
                <tr>
                  <th>Book By</th>
                  <td style="text-align: left; text-transform: capitalize;">${this.state?.bookingData?.destination?.book_by || '--'}</td></tr>
                ${
                  this.state?.bookingData?.destination?.book_by != 'day'
                    ? `<tr>
                      <th>Hours</th>
                      <td style="text-align: left">
                        ${this.state?.bookingData?.destination?.destination_min_hour || '--'}
                      </td>
                    </tr>`
                    : `<tr>
                        <th>Checkin time</th>
                        <td style="text-align: left">
                          ${this.state?.bookingData?.destination?.check_in_time || '--'}
                        </td>
                      </tr>
                      <tr>
                        <th>Checkout time</th>
                        <td style="text-align: left">
                          ${this.state?.bookingData?.destination?.check_out_time || '--'}
                        </td>
                      </tr>
                      <tr>
                        <th>Minimum Booking Days</th>
                        <td style="text-align: left">
                          ${this.state?.bookingData?.destination?.min_days || '--'}
                        </td>
                      </tr>
                      <tr>
                        <th>Maximum Booking Days</th>
                        <td style="text-align: left">
                          ${this.state?.bookingData?.destination?.max_days || '--'}
                        </td>
                      </tr>`
                }
                <tr>
                  <th>Price</th>
                  <td style="text-align: left">${this.state?.currency} ${this.state?.bookingData?.destination?.price || '--'}</td></tr>
              </tbody>
            </table>
          `,
        })
        break
      case 'payment':
        var content
        if (this.state?.bookingData?.payment_details.length > 0) {
          content = `<div><table style="width:100%">
              <tbody>
                <tr>
                  <th></th>
                  ${this.state?.bookingData?.payment_details.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
                </tr>
                <tr>
                  <th>Payment ID</th>
                  ${this.state?.bookingData?.payment_details.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
                </tr>
                <tr>
                  <th>Payment Status</th>
                  ${this.state?.bookingData?.payment_details
                    .map(
                      (item) =>
                        `<td style="text-align: left">
                        ${item.payment_status || '--'}
                        ${
                          item.payment_status === 'INITIATED' ||
                          item.payment_status === 'FAILED' ||
                          item.payment_status === 'PENDING'
                            ? `<i 
                              class="icofont icofont-refresh" 
                              onclick="window.syncPaymentHandler('${item.id}')" 
                              style="margin-left: 10px; cursor: pointer; color: #007bff; font-size: 18px;" 
                              title="Sync Payment">
                            </i>`
                            : ''
                        }
                      </td>`
                    )
                    .join('')}
                </tr>
                <tr>
                  <th>Payment Method</th>
                  ${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
                </tr>
                <tr>
                  <th>Payment Amount</th>
                  ${this.state?.bookingData?.payment_details
                    .map(
                      (item) => `
                  <td style="text-align: left; ${item.payment_amount < 0 ? 'background-color: red; color: white;' : ''}">
                    ${item.payment_currency || this.state.currency} ${item.payment_amount}
                  </td>
                  `
                    )
                    .join('')}
                </tr>
                <tr>
                  <th>Transaction ID</th>
                  ${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
                </tr>
                <tr>
                  <th>Invoice Reference ID</th>
                  ${this.state?.bookingData?.payment_details.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
                </tr>
                <tr>
                  <th>Invoice Reference ID</th>
                  ${this.state?.bookingData?.payment_details.map(
                    (item) =>
                      '<td style="text-align: left">' +
                      moment(item.created_at)
                        .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
                        .format('YYYY-MM-DD HH:mm:ss') +
                      '</td>'
                  )}
                </tr>
              </tbody>
            </table>
            </div>
          `
          // Attach sync payment handler to window for button onclick
          window.syncPaymentHandler = (paymentId) => {
            this.syncPayment(paymentId)
          }

          Swal.fire({
            width: '1000px',
            title: '<strong>Payment Details</strong>',
            html: content,
          })
        } else {
          Swal.fire({
            title: '<strong>Payment Details Not Found</strong>',
            icon: 'error',
            type: 'error',
          })
        }
        break
      default:
        break
    }
  }

  downloadTicket = async (type, order_number, from, ticket_for = 'user', source_id = null) => {
    function checkDimentions(width, height, a4Width = 210, a4Height = 297) {
      const aspectRatio = width / height
      const maxWidth = a4Width
      const maxHeight = maxWidth / aspectRatio
      return maxWidth <= a4Width && maxHeight <= a4Height
    }

    if (from == 'api') {
      this.setState({
        isLoading: true,
      })

      await axios
        .get(Constant?.getAPI() + `/auth/booking-tickets-v2`, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
          params: {
            type: 'C',
            order_number,
            ticket_for,
            lang: 'en',
            content_type: 'base64',
            source_id,
            without_qr_code: true,
          },
        })
        .then(async (res) => {
          if (type == 'pdf') {
            base64ToPdfDownload(res.data, `cruise-booking-${order_number}`)
          } else {
            base64ToImageDownload(res.data, `cruise-booking-${order_number}`)
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({
            isLoading: false,
          })
        })
    } else {
      const scaleFactor = 2
      let ticketBlock = document.querySelector('#booking-ticket-capture')
      ticketBlock.style.display = 'unset'
      ticketBlock.style.width *= scaleFactor
      let can_adjust = true
      let imgData

      await html2canvas(ticketBlock, { scale: scaleFactor }).then(async (canvas) => {
        can_adjust = checkDimentions(canvas.width, canvas.height)
        imgData = canvas.toDataURL('image/jpeg')
        ticketBlock.style.display = 'none'
        ticketBlock.style.width /= scaleFactor
      })

      if (type == 'pdf') {
        var pdf = new jsPDF()
        pdf.addImage(imgData, 'JPEG', 0, 0, can_adjust ? 210 : 0, can_adjust ? 0 : 297)

        pdf.save(`cruise-booking-${order_number}.pdf`)
      } else if (type == 'image') {
        const downloadLink = document.createElement('a')
        downloadLink.href = imgData
        downloadLink.download = `cruise-booking-${order_number}.jpeg`

        downloadLink.click()
      }
    }
  }

  getBookingShareLink = async (number, code, order_number, user_type) => {
    const scaleFactor = 2
    let ticketBlock = document.querySelector('#booking-ticket-capture')
    ticketBlock.style.display = 'unset'
    ticketBlock.style.width *= scaleFactor
    this.setState({
      whatsAppShare: user_type,
    })

    html2canvas(ticketBlock, { scale: scaleFactor }).then(async (canvas) => {
      var imgData = canvas.toDataURL('image/jpeg', 1.0)

      var pdf = new jsPDF()
      pdf.addImage(imgData, 'JPEG', 0, 0, 0, 297)

      const pdfName = `cruise-booking-${order_number}.pdf`
      let pdfData = pdf.output('blob')

      const formData = new FormData()
      formData.append('pdfData', pdfData, pdfName)
      formData.append('pdfName', pdfName)

      await axios
        .post(Constant?.getAPI() + '/booking/save-booking-detail-pdf', formData, {
          headers: {
            Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res?.data?.success) {
            let phoneNumber = code + number
            phoneNumber.replace(/\+/g, '')

            let text = ''
            if (user_type == 'captain') {
              text = `Dear Partner,\nYou have a new booking, please find the following link:\n${getImage()}/public/booking/cruise-booking-${order_number}.pdf`
            } else if (user_type == 'user') {
              text = `Dear User,\nThank you for booking with Waves! We are pleased to confirm your Booking.\nPlease find your booking confirmation by clicking on the following link:\n${getImage()}/public/booking/cruise-booking-${order_number}.pdf`
            }

            text = encodeURIComponent(text)

            window.open(`whatsapp://send?phone=${phoneNumber}&text=${text}`)
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          ticketBlock.style.display = 'none'
          this.setState({
            whatsAppShare: null,
          })
        })
    })
  }

  addEllipsis = (string = '', limit) => {
    return string.substring(0, limit) + (string.length > limit ? '...' : '')
  }

  updateNote = async () => {
    if (this.state?.note?.length > 0) {
      const data = {
        booking_id: this.state.bookingData.id,
        comment: this.state.note,
      }
      await axios
        .post(Constant.getAPI() + '/booking/update-note', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            Swal.fire('Updated !', 'Note Updated', 'success')
            this.getBookingDetails()
            this.setState({
              note: '',
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  handleChange = (event) => {
    event.preventDefault()
    this.setState({ [event.target.name]: event.target.value })
  }

  processRefund = async (state) => {
    if (!state?.refund_type) {
      Swal.fire('Refund Type Required!', '', 'error')
      return
    }
    this.setState({
      refundModel: false,
    })
    const data = {
      booking_id: this.state.bookingData.id,
      refund_type: state?.refund_type,
      refund_amount: state?.refund_amount,
      comment_en: `Amount of ${state?.refund_amount} refunded to ${state?.refund_type} - ${state?.comment_en}`,
      comment_ar: `كمية ${state?.refund_amount} ردها إلى ${state?.refund_type} - ${state?.comment_ar}`,
    }

    await axios
      .post(Constant.getAPI() + '/booking/cruise-refund', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Refund Processed', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getDownloadTicketButtons = (store_type) => {
    if (store_type == 'ADDONS') {
      return (
        <>
          {this.state?.addons_bookings?.length > 0 &&
            this.state?.addons_bookings?.map((item) => (
              <Button
                style={{ width: '100%' }}
                key={item.id}
                startIcon={<i className="icofont icofont-download m-r-5"></i>}
                onClick={() => {
                  this.downloadTicket('image', this.state.bookingData.order_number, 'api', 'addons', item.id)
                }}
              >
                {item.category} Ticket
              </Button>
            ))}
        </>
      )
    } else {
      return (
        <>
          {this.state?.[store_type == 'STORE' ? 'stores_booking' : 'waves_market_booking']?.map((item) => (
            <Button
              style={{ width: '100%' }}
              key={item.id}
              startIcon={<i className="icofont icofont-download m-r-5"></i>}
              onClick={() => {
                this.downloadTicket(
                  'image',
                  this.state.bookingData.order_number,
                  'api',
                  store_type == 'STORE' ? 'store' : 'food',
                  item.id
                )
              }}
            >
              {item.category} Ticket
            </Button>
          ))}
        </>
      )
    }
  }

  sendPayment = async (state) => {
    if (!state?.amount) {
      Swal.fire('Amount Required!', '', 'error')
      return
    }

    this.setState({
      sendPaymentModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.bookingData.id,
      amount: state?.amount,
    }

    await axios
      .post(Constant.getAPI() + '/booking/send-payment', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Request send successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  postComplaint = async (state) => {
    if (!state?.title) {
      Swal.fire('Title is Required!', '', 'error')
      return
    }
    if (!state?.description) {
      Swal.fire('Description is Required!', '', 'error')
      return
    }

    this.setState({
      complaintModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.bookingData.id,
      title: state?.title,
      description: state?.description,
      type: 'C',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint raised successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  postAction = async (state) => {
    if (!state?.action) {
      Swal.fire('Action is Required!', '', 'error')
      return
    }
    if (!state?.note) {
      Swal.fire('Note is Required!', '', 'error')
      return
    }

    this.setState({
      complaintActionModel: false,
      isLoading: true,
    })

    const data = {
      complaint_id: this.state.selectedComplaintId,
      action: state?.action,
      note: state?.note,
      type: 'C',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint-action', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint updated successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleStatusChange = async (id, status) => {
    const data = {
      complaint_id: id,
      status: status,
      type: 'C',
    }

    await axios
      .post(Constant.getAPI() + '/admin/update-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Status updated successfully', 'success')
          this.getBookingDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  syncPayment = async (paymentId) => {
    if (!paymentId) {
      Swal.fire({
        title: 'Payment ID is required',
        icon: 'error',
        type: 'error',
      })
      return
    }

    Swal.fire({
      title: 'Syncing Payment...',
      text: 'Please wait while we sync the payment status',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await axios
      .get(Constant.getAPI() + `/admin/sync-payment/${paymentId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.getBookingDetails()
        Swal.fire('Success', 'Payment synced successfully', 'success')
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            type: 'error',
          })
        }
      })
  }

  handleComplaintAction = (complaintId) => {
    this.setState({ complaintActionModel: true, selectedComplaintId: complaintId })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <Modal
          open={this.state.editBookingDetailsModel}
          onClose={() => {
            this.setState({ editBookingDetailsModel: false })
          }}
          center
          styles={customModelStyles}
        >
          <EditCruiseModel
            bookingDetails={this.state.bookingData}
            cruiseList={this.state.cruise_list}
            pickupList={this.state.pickup_list}
            destinationList={this.state.destination_list}
            editBookingCruise={this.changeBookingDetails}
          ></EditCruiseModel>
        </Modal>
        <Modal
          open={this.state.refundModel}
          onClose={() => {
            this.setState({ refundModel: false })
          }}
          center
        >
          <RefundModel
            refundAmount={
              this.state?.bookingData?.total_booking_amount +
                this.state?.bookingData?.wallet_amount_applied -
                this.state?.refunded_amount || '0'
            }
            processRefund={this.processRefund}
          ></RefundModel>
        </Modal>
        <Modal
          open={this.state.sendPaymentModel}
          onClose={() => {
            this.setState({ sendPaymentModel: false })
          }}
          center
        >
          <SendPayment sendPayment={this.sendPayment}></SendPayment>
        </Modal>
        <Modal
          open={this.state.complaintModel}
          onClose={() => {
            this.setState({ complaintModel: false })
          }}
          center
        >
          <ComplaintModel
            postComplaint={this.postComplaint}
            type={'C'}
          ></ComplaintModel>
        </Modal>
        <Modal
          open={this.state.complaintActionModel}
          onClose={() => {
            this.setState({ complaintActionModel: false })
          }}
          center
        >
          <ComplaintActionModel
            postAction={this.postAction}
            type={'C'}
          ></ComplaintActionModel>
        </Modal>
        <div className="main-body">
          <div className="page-wrapper">
            <div
              className="page-header"
              id="store-order-header"
            >
              <div className="row align-items-end">
                <div className="col-3">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Cruise Booking Details</h4>
                    </div>
                  </div>
                </div>
                {this.state?.bookingData && (
                  <div className="col-9 text-right">
                    <Button
                      style={{ backgroundColor: '#ee3a28' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ complaintModel: true })
                      }}
                      startIcon={<i className="icofont icofont-contacts m-r-5"></i>}
                    >
                      Raise Complaint
                    </Button>
                    <Button
                      startIcon={<i className="icofont icofont-card m-r-5"></i>}
                      style={{ backgroundColor: '#5fcd85' }}
                      onClick={() => {
                        if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                          Swal.fire(
                            '',
                            `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                            'error'
                          )
                          return
                        }
                        this.setState({ sendPaymentModel: true })
                      }}
                    >
                      Request Payment
                    </Button>
                    <CheckPermission permission={'refund-booking'}>
                      <Button
                        onClick={() => {
                          this.setState({ refundModel: true })
                        }}
                        disabled={
                          this.state?.refunded_amount >=
                          this.state?.bookingData?.total_booking_amount + this.state?.bookingData?.wallet_amount_applied
                        }
                        startIcon={<i className="icofont icofont-ui-rotation m-r-5"></i>}
                      >
                        Refund
                      </Button>
                    </CheckPermission>
                    {localStorage?.getItem('loged_In_role') != 'concierge' && (
                      <Button
                        startIcon={<i className="icofont icofont-ui-edit m-r-5"></i>}
                        onClick={() => {
                          if (localStorage.getItem('countryShortName') != this.state.bookingData.country) {
                            Swal.fire(
                              '',
                              `Please change country to ${this.state.bookingData.country} for edit this booking details`,
                              'error'
                            )
                            return
                          }
                          this.setState({ editBookingDetailsModel: true })
                        }}
                      >
                        Edit Booking
                      </Button>
                    )}
                    <Button
                      startIcon={<i className="icofont icofont-download m-r-5"></i>}
                      onClick={() => {
                        this.setState(
                          {
                            shop_id: '',
                            shop_type: '',
                            shop_total_amount: '',
                            shop_delivary_amount: '',
                            shop_vat_amount: '',
                          },
                          () => {
                            this.downloadTicket('image', this.state.bookingData.order_number, 'api')
                          }
                        )
                      }}
                    >
                      User Ticket Image
                    </Button>
                    <Button
                      startIcon={<i className="icofont icofont-download m-r-5"></i>}
                      onClick={() => {
                        this.setState(
                          {
                            shop_id: '',
                            shop_type: '',
                            shop_total_amount: '',
                            shop_delivary_amount: '',
                            shop_vat_amount: '',
                          },
                          () => {
                            this.downloadTicket('pdf', this.state.bookingData.order_number, 'api')
                          }
                        )
                      }}
                    >
                      User Ticket PDF
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <div
              className="page-body"
              id="store-order-details"
            >
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      {this.state?.bookingData ? (
                        <>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-md-6 col-sm-12"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Booking ID</div>
                                  <div>Booking Status</div>
                                  <div>Booking Type tag</div>
                                  <div>Booking Date</div>
                                  <div>Issue date & Time</div>
                                  <div>Booking Duration</div>
                                  {this.state?.bookingData?.destination?.book_by != 'day' && <div>TimeSlots</div>}
                                  <div>Source</div>
                                  <div>Click ID</div>
                                </div>
                                <div className="col-5">
                                  <div style={{ fontWeight: 'bolder' }}>
                                    {this.state.bookingData?.order_number || '--'}{' '}
                                    {this.state.bookingData?.from_flash_offer == true && (
                                      <img
                                        src={'./assets/images/ic_flash_icon.png'}
                                        alt="img"
                                        onError={(event) => {
                                          event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                        }}
                                        style={{ height: 20 }}
                                      />
                                    )}
                                  </div>
                                  <div style={{ fontWeight: 'bolder', color: 'green' }}>
                                    {this.state?.bookingData?.booking_status == 'Cancelled' ||
                                    this.state?.bookingData?.booking_cancel ? (
                                      <span className="badge badge-pill badge-warning">Cancelled</span>
                                    ) : ['Confirmed', 'Sailed'].includes(this.state?.bookingData?.booking_status) ? (
                                      <span className="badge badge-pill badge-success">
                                        {this.state?.bookingData?.booking_status}
                                      </span>
                                    ) : this.state?.bookingData?.booking_status == 'Postponed' ? (
                                      <span className="badge badge-pill badge-warning">Postponed</span>
                                    ) : this.state?.bookingData?.booking_status == 'Successful' ? (
                                      <span className="badge badge-pill badge-success">Successful</span>
                                    ) : this.state?.bookingData?.booking_status == 'Pending' &&
                                      this.state?.bookingData?.is_concierge_booking == true &&
                                      this.state?.bookingData?.payment_status == false ? (
                                      <span className="badge badge-pill badge-warning">Payment Pending</span>
                                    ) : this.state?.bookingData?.booking_status == 'Pending' &&
                                      this.state?.bookingData?.payment_status == true ? (
                                      <span className="badge badge-pill badge-warning">In Progress</span>
                                    ) : (
                                      <span className="badge badge-pill badge-warning">--</span>
                                    )}
                                  </div>
                                  <div>{this.state?.bookingData?.type_tag || '--'}</div>
                                  <div>
                                    {this.state?.bookingData?.destination?.book_by == 'day' ? (
                                      this.state?.bookingData?.booking_date +
                                      ' - ' +
                                      this.state?.bookingData?.booking_to_date
                                    ) : (
                                      <>
                                        {this.state?.bookingData?.booking_date || '--'}
                                        {' - '}
                                        {this.state?.bookingData?.slots[this.state?.bookingData?.slots?.length - 1]
                                          ?.slot_date
                                          ? this.state?.bookingData?.slots[this.state?.bookingData?.slots?.length - 1]
                                              ?.slot_date
                                          : this.state?.bookingData?.booking_date || '--'}
                                      </>
                                    )}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.payment_details &&
                                    this.state?.bookingData?.payment_details?.length > 0 ? (
                                      <Moment
                                        format="YYYY-MM-DD HH:mm A"
                                        tz={getCountryTimeZone(localStorage.getItem('countryShortName'))}
                                      >
                                        {this.state?.bookingData?.payment_details[0].created_at}
                                      </Moment>
                                    ) : (
                                      <Moment
                                        format="YYYY-MM-DD HH:mm A"
                                        tz={getCountryTimeZone(localStorage.getItem('countryShortName'))}
                                      >
                                        {this.state?.bookingData?.created_at}
                                      </Moment>
                                    )}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.destination?.book_by == 'day'
                                      ? moment(this.state?.bookingData?.booking_to_date, 'YYYY-MM-DD')
                                          .add(1, 'days')
                                          .diff(moment(this.state?.bookingData?.booking_date, 'YYYY-MM-DD'), 'days') +
                                        ' Days.'
                                      : this.state?.bookingData?.slots.length +
                                        (this.state?.bookingData?.slots.length > 1 ? ' Hrs.' : ' Hr.')}
                                  </div>
                                  {this.state?.bookingData?.destination?.book_by != 'day' && (
                                    <div>
                                      {this.state?.bookingData?.slots &&
                                        this.state?.bookingData?.slots.map((slot, i) => {
                                          return (
                                            <span key={i}>
                                              {slot.slot_from.substring(0, 5) + ', '}
                                              {i == this.state?.bookingData?.slots.length - 1 &&
                                                slot.slot_to.substring(0, 5)}
                                            </span>
                                          )
                                        })}
                                    </div>
                                  )}
                                  <div>{this.state?.bookingData?.wego_click_id ? 'Wego' : '--'}</div>
                                  <div>{this.state?.bookingData?.wego_click_id || '--'}</div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>User Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Customer Name</div>
                                  <div style={{ height: 50 }}>Profile</div>
                                  <div>Phone</div>
                                  <div>Email</div>
                                  <div>Device Type</div>
                                  <div>Device Name</div>
                                </div>
                                <div className="col-5">
                                  <div style={{ textTransform: 'capitalize' }}>
                                    {!this.state?.bookingData?.customer?.first_name &&
                                    !this.state?.bookingData?.customer?.last_name &&
                                    this.state?.bookingData?.customer?.is_guest
                                      ? 'Guest User'
                                      : this.state?.bookingData?.customer?.first_name &&
                                          this.state?.bookingData?.customer?.last_name
                                        ? this.state?.bookingData?.customer?.first_name +
                                          ' ' +
                                          this.state?.bookingData?.customer?.last_name
                                        : '--'}
                                  </div>
                                  <div style={{ height: 50 }}>
                                    <img
                                      src={
                                        this.state?.bookingData?.customer?.user_profile &&
                                        typeof this.state?.bookingData?.customer?.user_profile == 'string'
                                          ? Constant.getImage() + this.state?.bookingData?.customer?.user_profile
                                          : './assets/images/no_image.png'
                                      }
                                      className="img-fluid"
                                      alt="img"
                                      onError={(event) => {
                                        event.currentTarget.src = './assets/images/no_image.png'
                                      }}
                                      style={{ height: 40, border: '1px solid #aaa', borderRadius: 5 }}
                                    />
                                  </div>
                                  <div>
                                    {!this.state?.bookingData?.customer?.country_code &&
                                    !this.state?.bookingData?.customer?.phone
                                      ? '--'
                                      : this.state?.bookingData?.customer?.country_code +
                                        ' ' +
                                        this.state?.bookingData?.customer?.phone}
                                    {this.state.whatsAppShare != 'user' ? (
                                      <span
                                        onClick={() =>
                                          this.getBookingShareLink(
                                            this.state.bookingData.customer.phone,
                                            this.state.bookingData.customer.country_code,
                                            this.state.bookingData.order_number,
                                            'user'
                                          )
                                        }
                                        title="Booking Detail Share"
                                      >
                                        <img
                                          className="img-fluid m-l-5"
                                          src="./assets/images/whatsapp.png"
                                          alt="ico"
                                          style={{ width: 20 }}
                                        />
                                      </span>
                                    ) : (
                                      <>
                                        <WaveLoading
                                          color="#46C655"
                                          size="small"
                                        />
                                      </>
                                    )}
                                  </div>
                                  <div>{this.state?.bookingData?.customer?.email || '--'}</div>
                                  <div>
                                    {this.state?.bookingData?.device_type == 'W'
                                      ? 'Website'
                                      : this.state?.bookingData?.device_type || '--'}
                                  </div>
                                  <div>{this.state?.bookingData?.device_name || '--'}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-6"
                              style={{ borderRight: '1px solid #ddd' }}
                            >
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Cruise Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Cruise Name</div>
                                  <div>
                                    Pickup position
                                    <img
                                      className="img-fluid m-l-5"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={{ width: 13 }}
                                      onClick={() => this.showDetails('pickup')}
                                    />
                                  </div>
                                  <div>
                                    Destination
                                    <img
                                      className="img-fluid m-l-5"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={{ width: 13 }}
                                      onClick={() => this.showDetails('destination')}
                                    />
                                  </div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    <Link
                                      to={'/viewboat-details/Yacht/' + this.state?.bookingData?.cruise?.id}
                                      className="m-r-15 text-primary"
                                    >
                                      {this.state?.bookingData?.cruise?.cruise_name_en || '--'}
                                    </Link>
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.source_pickup
                                      ? this.state?.bookingData?.source_pickup?.pickup_address_en
                                      : this.state?.bookingData?.pickup?.pickup_address_en || '--'}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.source_destination
                                      ? this.state?.bookingData?.source_destination.destination_address_en
                                      : this.state?.bookingData?.destination?.destination_address_en || '--'}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Coupon Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Coupon Code</div>
                                  <div>Coupon Type</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this.state?.bookingData?.coupon_id &&
                                      this.state?.bookingData?.coupon_type +
                                        ' - ' +
                                        (this.state?.bookingData?.coupon_type == 'BC'
                                          ? this.state?.bookingData?.bulkCoupon?.coupon_code || '--'
                                          : this.state?.bookingData?.coupon?.coupon_code || '--')}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.bulkCoupon?.coupon_type ||
                                      this.state?.bookingData?.coupon?.coupon_type ||
                                      '--'}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-6">
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Captain Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Captain Name</div>
                                  <div>Captain Phone</div>
                                  <div>Captain Email</div>
                                </div>
                                <div className="col-5">
                                  <div>
                                    {this.state?.bookingData?.cruise?.captain?.first_name}{' '}
                                    {this.state?.bookingData?.cruise?.captain?.last_name}
                                  </div>
                                  <div>
                                    {this.state?.bookingData?.cruise?.captain?.country_code}{' '}
                                    {this.state?.bookingData?.cruise?.captain?.phone}
                                    {this.state.whatsAppShare != 'captain' ? (
                                      <a
                                        title="Booking Detail Share"
                                        onClick={() =>
                                          this.getBookingShareLink(
                                            this.state.bookingData.cruise.captain.phone,
                                            this.state.bookingData.cruise.captain.country_code,
                                            this.state.bookingData.order_number,
                                            'captain'
                                          )
                                        }
                                      >
                                        <img
                                          className="img-fluid m-l-5"
                                          src="./assets/images/whatsapp.png"
                                          alt="ico"
                                          style={{ width: 20 }}
                                        />
                                      </a>
                                    ) : (
                                      <>
                                        <WaveLoading
                                          color="#46C655"
                                          size="small"
                                        />
                                      </>
                                    )}
                                  </div>
                                  <div>{this.state?.bookingData?.cruise?.captain?.email || '--'}</div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  className="col-3"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>Payment Details</div>
                                </div>
                                <div
                                  className="col-4"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <div>
                                    Payment Status
                                    <img
                                      className="img-fluid m-l-5"
                                      src="./assets/images/info.png"
                                      alt="ico"
                                      style={{ width: 13 }}
                                      onClick={() => this.showDetails('payment')}
                                    />
                                  </div>
                                  <div>Service Charge</div>
                                  <div>Total Amount</div>
                                </div>
                                <div className="col-5">
                                  <div>{this.state?.bookingData?.payment_status === true ? 'True' : 'False'}</div>
                                  <div>
                                    {this.state?.currency + ' ' + this.state?.bookingData?.service_charge || '0'}
                                  </div>
                                  <div>
                                    {this.state?.currency + ' ' + this.state?.bookingData?.total_booking_amount || '0'}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ padding: 10 }}
                          >
                            <div className="col-12">
                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Add-ons
                                  <br />
                                  <Button
                                    style={{ width: '100%' }}
                                    startIcon={<i className="icofont icofont-download m-r-5"></i>}
                                    onClick={() => {
                                      this.downloadTicket('image', this.state.bookingData.order_number, 'api', 'owner')
                                    }}
                                  >
                                    OWNER Ticket
                                  </Button>
                                  {this.getDownloadTicketButtons('ADDONS')}
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Amount Goes To
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Shop Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Item Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Category
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Special Request
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Commision %
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Quantity
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivery charge
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Unit Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.diwaniya_items?.length > 0 &&
                                              this.state?.bookingData?.diwaniya_items.map((item) => (
                                                <tr
                                                  key={item.id}
                                                  style={
                                                    item?.payment_status
                                                      ? this.style.tableDataPaid
                                                      : this.style.tableDataUnpaid
                                                  }
                                                >
                                                  <td style={this.style.tableData}>
                                                    {item?.cruise_diwaniya?.diwaniya_master?.source || 'OWNER'}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {item?.cruise_diwaniya?.diwaniya_master?.wave_store?.shop_name_en ||
                                                      '--'}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {item?.cruise_diwaniya?.item_name_en || '--'}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {item?.cruise_diwaniya?.category?.name_en || '--'}
                                                  </td>
                                                  <td style={this.style.tableData}>{item.notes || '--'}</td>
                                                  <td style={this.style.tableData}>
                                                    {item?.payment_status === true ? (
                                                      <span className="badge badge-success">Success</span>
                                                    ) : (
                                                      <span className="badge badge-danger">Pending</span>
                                                    )}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {item?.cruise_diwaniya?.diwaniya_master?.wave_store
                                                      ?.store_commission || '--'}
                                                  </td>
                                                  <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                  <td style={this.style.tableData}>--</td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency + ' ' + item?.amount}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency + ' ' + item?.amount * item.item_qty}
                                                  </td>
                                                </tr>
                                              ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Waves Market
                                  <br />
                                  {this.getDownloadTicketButtons('FOOD')}
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Shop Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Item Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>SKU</th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Special Request
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Commision %
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Quantity
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivery charge
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Unit Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.additional_items?.length > 0 &&
                                              this.state?.bookingData?.additional_items
                                                .filter((item) => item?.store_item?.store?.shop_type == 'FOOD')
                                                .sort((a, b) => {
                                                  const storeNameA = a.store_item.store.shop_name_en.toUpperCase() // Ignore case
                                                  const storeNameB = b.store_item.store.shop_name_en.toUpperCase() // Ignore case

                                                  if (storeNameA < storeNameB) return -1
                                                  if (storeNameA > storeNameB) return 1
                                                  return 0
                                                })
                                                .map((item) => {
                                                  return (
                                                    <tr
                                                      key={item.id}
                                                      style={
                                                        item?.payment_status
                                                          ? this.style.tableDataPaid
                                                          : this.style.tableDataUnpaid
                                                      }
                                                    >
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.shop_name_en || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.item_name_en || '--'}
                                                        {item?.store_item_option?.name_en && (
                                                          <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.sku || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {item?.payment_status === true ? (
                                                          <span className="badge badge-success">Success</span>
                                                        ) : (
                                                          <span className="badge badge-danger">Pending</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.store_commission || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + (item.delivery_charge || '0')}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount * item.item_qty}
                                                      </td>
                                                    </tr>
                                                  )
                                                })}
                                            {this.state?.bookingData?.bulkCoupon?.coupon_type == 'drink' && (
                                              <tr style={this.style.tableDataPaid}>
                                                <td
                                                  style={{
                                                    ...this.style.tableData,
                                                    color: 'green',
                                                    fontWeight: 'bold',
                                                  }}
                                                >
                                                  Free Drinks
                                                </td>
                                                <td style={this.style.tableData}>--</td>
                                                <td style={this.style.tableData}>--</td>
                                                <td style={this.style.tableData}>--</td>
                                                <td
                                                  style={{
                                                    ...this.style.tableData,
                                                    color: 'green',
                                                    fontWeight: 'bold',
                                                  }}
                                                >
                                                  {this.state?.bookingData?.bulkCoupon?.no_of_drinks || 0}
                                                </td>
                                                <td style={this.style.tableData}>--</td>
                                                <td style={this.style.tableData}>{this.state?.currency + ' 0'}</td>
                                                <td style={this.style.tableData}>{this.state?.currency + ' 0'}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Stores
                                  <br />
                                  {this.getDownloadTicketButtons('STORE')}
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Shop Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Item Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>SKU</th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Special Request
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Commision %
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Quantity
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Delivery charge
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Unit Price
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.additional_items?.length > 0 &&
                                              this.state?.bookingData?.additional_items
                                                .filter((item) => item?.store_item?.store?.shop_type == 'STORE')
                                                .sort((a, b) => {
                                                  const storeNameA = a.store_item.store.shop_name_en.toUpperCase() // Ignore case
                                                  const storeNameB = b.store_item.store.shop_name_en.toUpperCase() // Ignore case

                                                  if (storeNameA < storeNameB) return -1
                                                  if (storeNameA > storeNameB) return 1
                                                  return 0
                                                })
                                                .map((item) => {
                                                  return (
                                                    <tr
                                                      key={item.id}
                                                      style={
                                                        item?.payment_status
                                                          ? this.style.tableDataPaid
                                                          : this.style.tableDataUnpaid
                                                      }
                                                    >
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.shop_name_en || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.item_name_en || '--'}
                                                        {item?.store_item_option?.name_en && (
                                                          <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.sku || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {item?.payment_status === true ? (
                                                          <span className="badge badge-success">Success</span>
                                                        ) : (
                                                          <span className="badge badge-danger">Pending</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {item?.store_item?.store?.store_commission || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item.item_qty || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + (item.delivery_charge || '0')}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.amount * item.item_qty}
                                                      </td>
                                                    </tr>
                                                  )
                                                })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Car Service
                                  <br />
                                  {this.state?.bookingData?.car_bookings?.map((item) => (
                                    <Button
                                      key={item.id}
                                      style={{ width: '100%' }}
                                      startIcon={<i className="icofont icofont-download m-r-5"></i>}
                                      onClick={() => {
                                        this.downloadTicket(
                                          'image',
                                          this.state.bookingData.order_number,
                                          'api',
                                          'limo',
                                          item.id
                                        )
                                      }}
                                    >
                                      {item.car?.car_company?.name_en} Ticket
                                    </Button>
                                  ))}
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Company Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Car Name
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Trip Type
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Pickup Point
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Destination Point
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Special Request
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Payment Status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Total
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.car_bookings?.length > 0 &&
                                              this.state?.bookingData?.car_bookings.map((item) => {
                                                return (
                                                  <>
                                                    <tr
                                                      key={item.id}
                                                      style={
                                                        item?.payment_status
                                                          ? this.style.tableDataPaid
                                                          : this.style.tableDataUnpaid
                                                      }
                                                    >
                                                      <td style={this.style.tableData}>
                                                        {item?.car?.car_company?.name_en || '--'}
                                                      </td>
                                                      <td style={this.style.tableData}>{item?.car?.name_en || '--'}</td>
                                                      <td style={this.style.tableData}>{item?.trip_type || '--'}</td>
                                                      {item?.trip_type === 'BEFORE' && (
                                                        <>
                                                          <td style={this.style.tableData}>
                                                            {item?.pickup_location || '--'}
                                                          </td>
                                                          <td style={this.style.tableData}>
                                                            {this.state?.bookingData?.pickup?.pickup_address_en || '--'}
                                                          </td>
                                                        </>
                                                      )}
                                                      {item?.trip_type === 'AFTER' && (
                                                        <>
                                                          <td style={this.style.tableData}>
                                                            {this.state?.bookingData?.pickup?.pickup_address_en || '--'}
                                                          </td>
                                                          <td style={this.style.tableData}>
                                                            {item?.drop_location || '--'}
                                                          </td>
                                                        </>
                                                      )}
                                                      {item?.trip_type === 'ROUND' && (
                                                        <>
                                                          <td style={this.style.tableData}>
                                                            {item?.pickup_location || '--'}
                                                          </td>
                                                          <td style={this.style.tableData}>
                                                            {item?.drop_location || '--'}
                                                          </td>
                                                        </>
                                                      )}
                                                      <td style={this.style.tableData}>{item?.notes || '--'}</td>
                                                      <td style={this.style.tableData}>
                                                        {item?.payment_status === true ? (
                                                          <span className="badge badge-success">Success</span>
                                                        ) : (
                                                          <span className="badge badge-danger">Pending</span>
                                                        )}
                                                      </td>
                                                      <td style={this.style.tableData}>
                                                        {this.state?.currency + ' ' + item?.total_amount}
                                                      </td>
                                                    </tr>
                                                    {item?.trip_type === 'ROUND' && (
                                                      <tr style={{ background: '#eee' }}>
                                                        <td
                                                          colSpan={10}
                                                          className=""
                                                        >
                                                          <table
                                                            key={item.id}
                                                            className="table"
                                                          >
                                                            <tbody>
                                                              <tr
                                                                className="thead-inverse"
                                                                style={{ height: 20, background: '#555' }}
                                                              >
                                                                <th
                                                                  style={{
                                                                    paddingLeft: 10,
                                                                    paddingTop: 8,
                                                                    paddingBottom: 5,
                                                                    background: '#999',
                                                                  }}
                                                                >
                                                                  Title
                                                                </th>
                                                                <th
                                                                  style={{
                                                                    paddingLeft: 10,
                                                                    paddingTop: 8,
                                                                    paddingBottom: 5,
                                                                    background: '#999',
                                                                  }}
                                                                >
                                                                  Pickup Location
                                                                </th>
                                                                <th
                                                                  style={{
                                                                    paddingLeft: 10,
                                                                    paddingTop: 8,
                                                                    paddingBottom: 5,
                                                                    background: '#999',
                                                                  }}
                                                                >
                                                                  Drop Location
                                                                </th>
                                                                <th
                                                                  style={{
                                                                    paddingLeft: 10,
                                                                    paddingTop: 8,
                                                                    paddingBottom: 5,
                                                                    background: '#999',
                                                                  }}
                                                                >
                                                                  Unit Price
                                                                </th>
                                                              </tr>
                                                              {item?.car_trip_data.map((ele) => (
                                                                <tr key={item.title}>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {ele.title || '--'}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {ele?.pickup_area || '--'}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {ele?.drop_area || '--'}
                                                                  </td>
                                                                  <td
                                                                    style={{
                                                                      ...this.style.tableData,
                                                                      background: '#eec',
                                                                    }}
                                                                  >
                                                                    {this.state?.currency + ' ' + ele.trip_amount}
                                                                  </td>
                                                                </tr>
                                                              ))}
                                                            </tbody>
                                                          </table>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </>
                                                )
                                              })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ borderBottom: '1px solid #ddd' }}
                              >
                                <div
                                  className="col-6"
                                  style={{ fontWeight: 'bold' }}
                                ></div>
                                <div className="col-6">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Description
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Price
                                              </th>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>
                                                {'Cruise Price'}
                                                {this.state?.bookingData?.destination?.book_by != 'day' && (
                                                  <>
                                                    <br />
                                                    {' Destination '}
                                                    {this.state?.bookingData?.destination?.destination_min_hour || '--'}
                                                    {'Hr'}
                                                  </>
                                                )}
                                              </td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.bookingData?.destination_fee || '0'}
                                              </td>
                                            </tr>
                                            {this.state?.bookingData?.destination?.book_by != 'day' && (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>
                                                  {'Additional Hours - '}
                                                  {this.state?.additional_hr || 0}
                                                </td>
                                                <td style={this.style.tableData}>
                                                  {this.state?.currency}{' '}
                                                  {this.state?.additional_hr
                                                    ? this.state?.bookingData?.booking_amount -
                                                      this.state?.bookingData?.destination_fee
                                                    : '--'}
                                                </td>
                                              </tr>
                                            )}
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Add-ons'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.diwaniya_total_price || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Waves Market'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency}{' '}
                                                {this.state?.waves_market_total_price
                                                  ? parseFloat(this.state?.waves_market_total_price || 0).toFixed(2)
                                                  : 0}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Stores'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.store_total_price || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Delivery Charges'}</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency} {this.state?.delivery_total_price || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>VAT</td>
                                              <td style={this.style.tableData}>
                                                {this.state?.currency}{' '}
                                                {parseFloat(
                                                  this.state.bookingData?.vat_amount || this.state?.total_Vat || 0
                                                ).toFixed(2)}
                                              </td>
                                            </tr>
                                            {this.state?.bookingData?.cost_of_service > 0 && (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'Cost Of Service'}</td>
                                                <td style={this.style.tableData}>
                                                  {this.state?.currency}{' '}
                                                  {this.state?.bookingData?.cost_of_service || '0'}
                                                </td>
                                              </tr>
                                            )}
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>{'Discount Coupon'}</td>
                                              <td style={{ ...this.style.tableData, color: 'red' }}>
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.coupon_applied_amount || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={this.style.tableData}>
                                                {'Wallet Amount Applied'}
                                                {this.state?.bookingData?.wallet_amount_applied > 0 && (
                                                  <Link
                                                    to={
                                                      '/all-users/edit/user-wallet/' +
                                                      this.state?.bookingData?.customer?.id
                                                    }
                                                    className="m-r-15 text-muted"
                                                  >
                                                    <img
                                                      className="img-fluid m-l-5"
                                                      src="./assets/images/info.png"
                                                      alt="ico"
                                                      style={{ width: 13 }}
                                                    />
                                                  </Link>
                                                )}
                                              </td>
                                              <td style={{ ...this.style.tableData, color: 'red' }}>
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.wallet_amount_applied || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {'Extra Payment'}
                                              </td>
                                              <td
                                                style={{
                                                  ...this.style.tableData,
                                                  fontWeight: 'bolder',
                                                  color: '#0004ff',
                                                }}
                                              >
                                                {this.state?.currency} {this.state?.bookingData?.extra_payment || '0'}
                                              </td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {'Total Amount'}
                                              </td>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {this.state?.currency}{' '}
                                                {this.state?.bookingData?.total_booking_amount || 0}
                                              </td>
                                            </tr>
                                            {this.state?.refunded_amount > 0 && (
                                              <>
                                                <tr style={this.style.tableDataPaid}>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                    {'Refunded Amount'}
                                                  </td>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                    {this.state?.currency} {this.state?.refunded_amount || '0'}
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Booking History
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Comments
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Change Time
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Change by
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.booking_statuses?.length > 0 ? (
                                              this.state?.bookingData?.booking_statuses?.map((booking) => {
                                                return (
                                                  <tr
                                                    key={booking.id}
                                                    style={this.style.tableDataPaid}
                                                  >
                                                    <td style={this.style.tableData}>{booking.status}</td>
                                                    <td style={this.style.tableData}>{booking.comment}</td>
                                                    <td style={this.style.tableData}>
                                                      {moment(booking.created_at)
                                                        .tz(
                                                          getCountryTimeZone(localStorage.getItem('countryShortName'))
                                                        )
                                                        .format('YYYY-MM-DD HH:mm:ss')}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.created_by == 1
                                                        ? 'System'
                                                        : `${booking.user?.first_name} ${booking.user?.last_name} (${booking.user?.user_type})`}
                                                    </td>
                                                  </tr>
                                                )
                                              })
                                            ) : (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Complaint History
                                </div>
                                <div className="col-10">
                                  <div className="row">
                                    <div className="col-sm-12">
                                      <div className="table-responsive">
                                        <table className="table">
                                          <tbody>
                                            <tr
                                              className="thead-inverse"
                                              style={{ height: 40 }}
                                            >
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Title
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Description
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Status
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Action Taken
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Change Time
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Created by
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Updated by
                                              </th>
                                              <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                                Action
                                              </th>
                                            </tr>
                                            {this.state?.bookingData?.complaints?.length > 0 ? (
                                              this.state?.bookingData?.complaints?.map((booking) => {
                                                return (
                                                  <tr
                                                    key={booking.id}
                                                    style={this.style.tableDataPaid}
                                                  >
                                                    <td style={this.style.tableData}>{booking.title}</td>
                                                    <td style={this.style.tableData}>{booking.description}</td>
                                                    <td style={this.style.tableData}>
                                                      <select
                                                        style={{ minWidth: 150 }}
                                                        className={`form-control`}
                                                        value={booking.status}
                                                        onChange={(e) =>
                                                          this.handleStatusChange(booking.id, e.target.value)
                                                        }
                                                      >
                                                        <option value="Open">Open</option>
                                                        <option value="In Progress">In Progress</option>
                                                        <option value="Resolved">Resolved</option>
                                                        <option value="Closed">Closed</option>
                                                      </select>
                                                    </td>
                                                    <td style={this.style.tableData}>{booking.action}</td>
                                                    <td style={this.style.tableData}>
                                                      {moment(booking.created_at)
                                                        .tz(
                                                          getCountryTimeZone(localStorage.getItem('countryShortName'))
                                                        )
                                                        .format('YYYY-MM-DD HH:mm:ss')}
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.created_user?.first_name}{' '}
                                                      {booking.created_user?.last_name}{' '}
                                                      <b>({booking.created_user?.user_type})</b>
                                                    </td>
                                                    <td style={this.style.tableData}>
                                                      {booking.updated_user?.first_name}{' '}
                                                      {booking.updated_user?.last_name}{' '}
                                                      <b>({booking.updated_user?.user_type})</b>
                                                    </td>
                                                    <td style={{ ...this.style.tableData, paddingLeft: 35 }}>
                                                      <i
                                                        className="icofont icofont-edit"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => this.handleComplaintAction(booking.id)}
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                )
                                              })
                                            ) : (
                                              <tr style={this.style.tableDataPaid}>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                                <td style={this.style.tableData}>{'--'}</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: 10 }}
                              >
                                <div
                                  className="col-2"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  Add Note
                                </div>
                                <div className="col-8">
                                  <textarea
                                    type="text"
                                    rows={4}
                                    className="form-control"
                                    name="note"
                                    placeholder="Add Note"
                                    onChange={this.handleChange}
                                    value={this.state.note}
                                  />
                                </div>
                                <div
                                  className="col-2 p-l-10"
                                  style={{ fontWeight: 'bold' }}
                                >
                                  <Button
                                    onClick={() => {
                                      this.updateNote()
                                    }}
                                    style={{ width: '100%' }}
                                  >
                                    Save
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginTop: 10 }}
                          >
                            <div
                              className="p-20"
                              id="booking-ticket-capture"
                              // style={{ border: '1px solid #ddd', width: 450 }}
                              style={{ border: '1px solid #ddd', width: 450, display: 'none' }}
                            >
                              <div className="row p-10">
                                <div className="col-12 ticket-block">
                                  <div className="row">
                                    <div className="ticket-header">
                                      <span style={{ marginTop: 10 }}>
                                        Booking ID: {this.state.bookingData?.order_number || '--'}{' '}
                                        {this.state.bookingData?.from_flash_offer == true && (
                                          <img
                                            src={'./assets/images/ic_flash_icon.png'}
                                            alt="img"
                                            onError={(event) => {
                                              event.currentTarget.src = './assets/images/ic_flash_icon.png'
                                            }}
                                            style={{ height: 20 }}
                                          />
                                        )}
                                      </span>
                                      <img
                                        width="100"
                                        src="./assets/images/icon2.png"
                                        alt=""
                                      ></img>
                                    </div>
                                  </div>
                                  <div className="row m-t-10">
                                    <div className="col-12 text-center">
                                      <div className="cruise-name dark-blue-color">
                                        {this.state?.bookingData?.cruise?.cruise_name_en}
                                      </div>
                                    </div>
                                    <div className="col-4 text-left">
                                      <div className="font-weight-bold dark-blue-color">From</div>
                                      <div className="booking-day">
                                        {this.state?.bookingData?.booking_date
                                          ? moment(this.state?.bookingData?.booking_date, 'YYYY-MM-DD').format(
                                              'ddd, DD MMM'
                                            )
                                          : '--'}
                                        <br />
                                        {this.state?.bookingData?.slots &&
                                          moment(
                                            this.state?.bookingData?.slots[0]?.slot_from?.substring(0, 5),
                                            'HH:mm'
                                          ).format('hh:mm A')}
                                      </div>
                                      <div className="light-blue-color font-weight-bold text-ellipsis">
                                        {this.addEllipsis(this.state?.bookingData?.pickup?.pickup_address_en, 14)}
                                      </div>
                                      <div className="booking-day text-ellipsis">
                                        {this.addEllipsis(this.state?.bookingData?.pickup?.pickup_address_en, 20)}
                                      </div>
                                    </div>

                                    <div className="col-4 text-center">
                                      <div className="m-t-20">
                                        {this.state?.cruise_img_base64 ? (
                                          <img
                                            width="100"
                                            src={this.state?.cruise_img_base64}
                                            alt=""
                                            style={{ borderRadius: 10 }}
                                            onError={(event) => {
                                              event.currentTarget.src = '/assets/images/icon.png'
                                            }}
                                          />
                                        ) : (
                                          <img
                                            width="100"
                                            src="/assets/images/icon.png"
                                            alt=""
                                            style={{ borderRadius: 10 }}
                                          />
                                        )}
                                      </div>
                                      <div className="m-t-20">
                                        {this.state?.bookingData?.slots.length}
                                        {this.state?.bookingData?.slots.length > 1 ? ' Hrs.' : ' Hr.'}
                                      </div>
                                    </div>

                                    <div className="col-4 text-right">
                                      <div className="font-weight-bold dark-blue-color">To</div>
                                      <div className="booking-day">
                                        {this.state?.bookingData?.slots[this.state?.bookingData?.slots?.length - 1]
                                          ?.slot_date
                                          ? moment(
                                              this.state?.bookingData?.slots[this.state?.bookingData?.slots?.length - 1]
                                                ?.slot_date,
                                              'YYYY-MM-DD'
                                            ).format('ddd, DD MMM')
                                          : this.state?.bookingData?.booking_date
                                            ? moment(this.state?.bookingData?.booking_date, 'YYYY-MM-DD').format(
                                                'ddd, DD MMM'
                                              )
                                            : '--'}
                                        <br />
                                        {this.state?.bookingData?.slots &&
                                          moment(
                                            this.state?.bookingData?.slots[
                                              this.state?.bookingData?.slots.length - 1
                                            ]?.slot_from?.substring(0, 5),
                                            'HH:mm'
                                          )
                                            .add(1, 'hour')
                                            .format('hh:mm A')}
                                      </div>
                                      <div
                                        className="light-blue-color font-weight-bold text-ellipsis"
                                        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                      >
                                        {this.addEllipsis(
                                          this.state?.bookingData?.destination?.destination_address_en,
                                          14
                                        )}
                                      </div>
                                      <div className="booking-day text-ellipsis">
                                        {this.addEllipsis(this.state?.bookingData?.pickup?.pickup_address_en, 20)}
                                      </div>
                                    </div>
                                    <div className="col-12 text-center">
                                      <div>{this.state?.bookingData?.pickup?.pickup_map.substring(0, 50)}</div>
                                    </div>
                                  </div>
                                  <div className="dotted-line m-t-20 m-b-20">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  {this.state.ticket_type == '' && (
                                    <>
                                      <div className="text-center font-weight-bold dark-blue-color m-b-10">Captain</div>
                                      <div className="row">
                                        <div className="col-4 text-left">
                                          <div className="font-weight-bold light-blue-color">Name</div>
                                        </div>

                                        <div className="col-8 text-right">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.cruise?.captain?.first_name}{' '}
                                            {this.state?.bookingData?.cruise?.captain?.last_name}
                                          </div>
                                        </div>

                                        <div className="h-line"></div>

                                        <div className="col-4 text-left">
                                          <div className="font-weight-bold light-blue-color">Phone</div>
                                        </div>

                                        <div className="col-8 text-right">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.cruise?.captain?.country_code}{' '}
                                            {this.state?.bookingData?.cruise?.captain?.phone}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  {this.state.ticket_type == 'CAR' && (
                                    <>
                                      <div className="text-center font-weight-bold dark-blue-color m-b-10">
                                        Customer
                                      </div>
                                      <div className="row">
                                        <div className="col-4 text-left">
                                          <div className="font-weight-bold light-blue-color">Name</div>
                                        </div>
                                        <div className="col-8 text-right">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.customer?.first_name}{' '}
                                            {this.state?.bookingData?.customer?.last_name}
                                          </div>
                                        </div>
                                        <div className="h-line"></div>
                                        <div className="col-4 text-left">
                                          <div className="font-weight-bold light-blue-color">Phone</div>
                                        </div>
                                        <div className="col-8 text-right">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.cruise?.captain?.country_code}{' '}
                                            {this.state?.bookingData?.customer?.phone}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  )}

                                  <div className="dotted-line m-t-40 m-b-25">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  <div className="row">
                                    {((this.state.shop_type == 'ADDONS' && this.state.shop_category == 'OWNER') ||
                                      this.state.shop_type == '') && (
                                      <>
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">
                                            Trip to{' '}
                                            {this.state?.bookingData?.destination?.destination_address_en || '--'}(
                                            {this.state?.bookingData?.slots.length}
                                            {this.state?.bookingData?.slots.length > 1 ? ' Hrs' : ' Hr'})
                                          </div>
                                        </div>

                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.destination_fee || '0'} {this.state?.currency}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                    {this.state.show_delivary &&
                                      (this.state?.bookingData?.diwaniya_items?.length > 0 ||
                                        (this.state.shop_type != '' && this.state.shop_type != 'ADDONS') ||
                                        !(this.state.shop_type == 'ADDONS' && this.state.shop_category == 'OWNER')) && (
                                        <div className="col-12 text-center">
                                          <div className="f-18 font-weight-bold text-danger">
                                            Delivery Time -{' '}
                                            {this.state?.bookingData?.booking_date &&
                                              this.state?.bookingData?.slots[0]?.slot_from &&
                                              moment(
                                                this.state?.bookingData?.booking_date +
                                                  ' ' +
                                                  this.state?.bookingData?.slots[0]?.slot_from?.substring(0, 5),
                                                'YYYY-MM-DD HH:mm'
                                              )
                                                .add(-30, 'minutes')
                                                .format('ddd, DD MMM hh:mm A')}
                                          </div>
                                        </div>
                                      )}

                                    {((this.state.shop_type == 'ADDONS' &&
                                      this.state?.addons_bookings.filter(
                                        (item) => item?.id == this.state?.shop_id || item?.id == null
                                      ).length > 0) ||
                                      (this.state.shop_type == 'FOOD' &&
                                        this.state?.waves_market_booking?.length > 0) ||
                                      (this.state.shop_type == 'STORE' && this.state?.stores_booking?.length > 0) ||
                                      (this.state.shop_type != 'ADDONS' &&
                                        this.state.shop_type != 'FOOD' &&
                                        this.state.shop_type != 'STORE' &&
                                        (this.state?.addons_bookings?.length > 0 ||
                                          this.state?.waves_market_booking?.length > 0 ||
                                          this.state?.stores_booking?.length > 0))) &&
                                    this.state?.ticket_type != 'CAR' ? (
                                      <div className="col-12 text-center font-weight-bold dark-blue-color m-t-10">
                                        Waves Market
                                      </div>
                                    ) : (
                                      <></>
                                    )}

                                    {this.state.shop_type == 'ADDONS' &&
                                      this.state?.bookingData?.diwaniya_items?.length > 0 && (
                                        <>
                                          {this.state?.addons_bookings.filter(
                                            (item) => item?.id == this.state?.shop_id || item?.id == null
                                          ).length > 0 && (
                                            <div className="col-12 text-left m-t-10 m-b-10">
                                              <div className="font-weight-bold light-blue-color">Add-ons</div>
                                            </div>
                                          )}
                                          {this.state?.addons_bookings
                                            // .filter((item) => item.id == this.state.shop_id || item.id == null)
                                            .filter((item) => item.id == this.state.shop_id)
                                            .map(({ category, id }) => (
                                              <>
                                                <div className="col-12 text-left">
                                                  <div className="font-weight-bold">
                                                    {category == 'OWNER' ? '' : category}
                                                  </div>
                                                </div>
                                                {this.state?.bookingData?.diwaniya_items
                                                  .filter(
                                                    (item) =>
                                                      (item?.payment_status == true &&
                                                        id &&
                                                        item?.cruise_diwaniya?.diwaniya_master?.store_id == id) ||
                                                      (item?.payment_status == true &&
                                                        !id &&
                                                        category == 'OWNER' &&
                                                        (item?.cruise_diwaniya?.diwaniya_master == null ||
                                                          item?.cruise_diwaniya?.diwaniya_master.source == 'OWNER'))
                                                    // item?.cruise_diwaniya?.diwaniya_master?.source == category ||
                                                    // (category == 'OWNER' && item?.cruise_diwaniya?.diwaniya_master == null)
                                                  )
                                                  .map((item) => (
                                                    <>
                                                      <div className="col-8 text-left">
                                                        <div className="">
                                                          {item?.cruise_diwaniya?.item_name_en || '--'} x{' '}
                                                          {item.item_qty || '--'}
                                                        </div>
                                                      </div>

                                                      <div className="col-4 text-right">
                                                        <div className="">
                                                          {item?.amount * item.item_qty + ' ' + this.state?.currency}
                                                        </div>
                                                      </div>
                                                    </>
                                                  ))}
                                              </>
                                            ))}
                                        </>
                                      )}
                                    {this.state.shop_type == '' &&
                                      this.state?.bookingData?.diwaniya_items?.length > 0 && (
                                        <>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Add-ons</div>
                                          </div>
                                          {[
                                            ...new Set(
                                              this.state?.bookingData?.diwaniya_items.map(
                                                (item) =>
                                                  item?.payment_status == true &&
                                                  item?.cruise_diwaniya?.category?.name_en
                                              )
                                            ),
                                          ].map((category) => (
                                            <>
                                              <div className="col-12 text-left">
                                                <div className="font-weight-bold">{category}</div>
                                              </div>
                                              {this.state?.bookingData?.diwaniya_items
                                                .filter((item) => item?.payment_status == true)
                                                .map(
                                                  (item) =>
                                                    category == item.cruise_diwaniya?.category?.name_en && (
                                                      <>
                                                        <div className="col-8 text-left">
                                                          <div className="">
                                                            {item?.cruise_diwaniya?.item_name_en || '--'} x{' '}
                                                            {item.item_qty || '--'}
                                                          </div>
                                                        </div>

                                                        <div className="col-4 text-right">
                                                          <div className="">
                                                            {item?.amount * item.item_qty + ' ' + this.state?.currency}
                                                          </div>
                                                        </div>
                                                      </>
                                                    )
                                                )}
                                            </>
                                          ))}
                                        </>
                                      )}
                                    {(this.state.shop_type == 'FOOD' || this.state.shop_type == '') &&
                                      this.state.ticket_type != 'CAR' &&
                                      this.state?.waves_market_booking?.length > 0 && (
                                        <>
                                          <div className="h-line"></div>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Waves Market</div>
                                          </div>
                                          {this.state?.waves_market_booking
                                            .filter((item) => this.state.shop_id == '' || item.id == this.state.shop_id)
                                            .map(({ category }) => (
                                              <>
                                                <div className="col-12 text-left">
                                                  <div className="font-weight-bold">{category}</div>
                                                </div>
                                                {this.state?.bookingData?.additional_items
                                                  .filter(
                                                    (item) =>
                                                      item?.payment_status == true &&
                                                      item?.store_item?.store?.shop_name_en == category
                                                  )
                                                  .map((item) => (
                                                    <>
                                                      <div className="col-8 text-left">
                                                        <div className="">
                                                          {item?.store_item?.item_name_en || '--'}
                                                          {item?.store_item_option?.name_en && (
                                                            <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                          )}{' '}
                                                          x {item.item_qty || '--'}
                                                        </div>
                                                      </div>

                                                      <div className="col-4 text-right">
                                                        <div className="">
                                                          {item?.amount * item.item_qty + ' ' + this.state?.currency}
                                                        </div>
                                                      </div>
                                                    </>
                                                  ))}
                                              </>
                                            ))}
                                        </>
                                      )}
                                    {(this.state.shop_type == 'STORE' || this.state.shop_type == '') &&
                                      this.state.ticket_type != 'CAR' &&
                                      this.state?.stores_booking?.length > 0 && (
                                        <>
                                          <div className="h-line"></div>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Stores</div>
                                          </div>
                                          {this.state?.stores_booking
                                            .filter((item) => this.state.shop_id == '' || item.id == this.state.shop_id)
                                            .map(({ category }) => (
                                              <>
                                                <div className="col-12 text-left">
                                                  <div className="font-weight-bold">{category}</div>
                                                </div>
                                                {this.state?.bookingData?.additional_items
                                                  .filter(
                                                    (item) =>
                                                      item?.payment_status == true &&
                                                      item?.store_item?.store?.shop_name_en == category
                                                  )
                                                  .map((item) => (
                                                    <>
                                                      <div className="col-8 text-left">
                                                        <div className="">
                                                          {item?.store_item?.item_name_en || '--'}
                                                          {item?.store_item_option?.name_en && (
                                                            <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                          )}{' '}
                                                          x {item.item_qty || '--'}
                                                        </div>
                                                      </div>

                                                      <div className="col-4 text-right">
                                                        <div className="">
                                                          {item?.amount * item.item_qty + ' ' + this.state?.currency}
                                                        </div>
                                                      </div>
                                                    </>
                                                  ))}
                                              </>
                                            ))}
                                        </>
                                      )}
                                    {(this.state.ticket_type == 'CAR' || this.state.shop_type == '') &&
                                      this.state?.bookingData?.car_bookings?.length > 0 && (
                                        <>
                                          <div className="h-line"></div>
                                          <div className="col-12 text-left m-t-10 m-b-10">
                                            <div className="font-weight-bold light-blue-color">Limousine</div>
                                          </div>
                                          {this.state?.bookingData?.car_bookings.map((ele, index) => (
                                            <div
                                              key={index}
                                              className="row m-0"
                                            >
                                              <div className="col-8 text-left">
                                                <div className="font-weight-bold">{ele?.car?.car_company?.name_en}</div>
                                                <div className="font-weight-light">{ele?.car?.name_en}</div>
                                              </div>
                                              <div className="col-4 text-right">
                                                <div className="font-weight-bold">
                                                  {ele?.total_amount} {this.state?.currency}
                                                </div>
                                              </div>
                                              <div className="h-line"></div>
                                              {ele.trip_type === 'ROUND' && (
                                                <>
                                                  <div className="col-12 text-center m-t-10">
                                                    <div>
                                                      <div className="font-weight-bold">
                                                        Pick up location for first trip
                                                      </div>
                                                      <div className="row">
                                                        <div className="col-4">
                                                          <div className="font-weight-bold light-blue-color">From</div>
                                                          <div>{ele?.pickup_location}</div>
                                                        </div>
                                                        <div className="col-4">
                                                          <img
                                                            className="img-fluid img-60 m-t-20"
                                                            src="./assets/images/carpool-revert.png"
                                                            alt="Carpool"
                                                          />
                                                        </div>
                                                        <div className="col-4">
                                                          <div className="font-weight-bold light-blue-color">To</div>
                                                          <div>{this.state.bookingData?.pickup?.pickup_address_en}</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="col-12 text-center m-t-10">
                                                    <div className="">
                                                      <div className="font-weight-bold">
                                                        Destination Location for second trip
                                                      </div>
                                                      <div className="row">
                                                        <div className="col-4">
                                                          <div className="font-weight-bold light-blue-color">From</div>
                                                          <div>{this.state.bookingData?.pickup?.pickup_address_en}</div>
                                                        </div>
                                                        <div className="col-4">
                                                          <img
                                                            className="img-fluid img-60 m-t-20"
                                                            src="./assets/images/carpool-revert.png"
                                                            alt="Carpool"
                                                          ></img>
                                                        </div>
                                                        <div className="col-4">
                                                          <div className="font-weight-bold light-blue-color">To</div>
                                                          <div>{ele?.car_trip_data?.[1]?.drop_area}</div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                              {ele.trip_type === 'BEFORE' && (
                                                <div className="col-12 text-center m-t-10">
                                                  <div>
                                                    <div className="font-weight-bold">
                                                      Pick up location for first trip
                                                    </div>
                                                    <div className="row">
                                                      <div className="col-4">
                                                        <div className="font-weight-bold light-blue-color">From</div>
                                                        <div>{ele?.pickup_location}</div>
                                                      </div>
                                                      <div className="col-4">
                                                        <img
                                                          className="img-fluid img-60 m-t-20"
                                                          src="./assets/images/carpool-revert.png"
                                                          alt="Carpool"
                                                        />
                                                      </div>
                                                      <div className="col-4">
                                                        <div className="font-weight-bold light-blue-color">To</div>
                                                        <div>{this.state.bookingData?.pickup?.pickup_address_en}</div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                              {ele.trip_type === 'AFTER' && (
                                                <div className="col-12 text-center m-t-10">
                                                  <div>
                                                    <div className="font-weight-bold">
                                                      Destination Location for second trip
                                                    </div>
                                                    <div className="row">
                                                      <div className="col-4">
                                                        <div className="font-weight-bold light-blue-color">From</div>
                                                        <div>{this.state.bookingData?.pickup?.pickup_address_en}</div>
                                                      </div>
                                                      <div className="col-4">
                                                        <img
                                                          className="img-fluid img-60 m-t-20"
                                                          src="./assets/images/carpool-revert.png"
                                                          alt="Carpool"
                                                        />
                                                      </div>
                                                      <div className="col-4">
                                                        <div className="font-weight-bold light-blue-color">To</div>
                                                        <div>{ele?.drop_location}</div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                          ))}
                                        </>
                                      )}
                                    {this.state.shop_type == '' &&
                                      this.state?.bookingData?.bulkCoupon?.coupon_type == 'drink' && (
                                        <>
                                          <div className="h-line"></div>
                                          <div className="col-8 text-left">
                                            <div className="">
                                              Free Drinks x {this.state?.bookingData?.bulkCoupon?.no_of_drinks || 0}
                                            </div>
                                          </div>

                                          <div className="col-4 text-right">
                                            <div className="">
                                              {'0'} {this.state?.currency}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    {/* If downloading store ticket */}
                                    {this.state.shop_type != '' && (
                                      <>
                                        {this.state?.shop_delivary_amount > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Delivery Charges</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {this.state?.shop_delivary_amount || '0'} {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {this.state?.shop_vat_amount > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Vat</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {parseFloat(this.state?.shop_vat_amount || 0).toFixed(2)}{' '}
                                                {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        <div className="h-line"></div>
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">Total Amount</div>
                                        </div>
                                        <div className="col-4 text-right">
                                          <div className="font-weight-bold">
                                            {this.state.shop_total_amount || 0} {this.state?.currency}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                    {/* If downloading full ticket */}
                                    {this.state.shop_type == '' && (
                                      <>
                                        {this.state?.delivery_total_price > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Delivery Charges</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {this.state?.delivery_total_price || '0'} {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {(this.state.bookingData?.vat_amount > 0 || this.state?.total_Vat > 0) && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Vat</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                {parseFloat(
                                                  this.state.bookingData?.vat_amount || this.state?.total_Vat || 0
                                                ).toFixed(2)}{' '}
                                                {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {this.state?.bookingData?.coupon_applied_amount > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Coupon Amount</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                -{this.state?.bookingData?.coupon_applied_amount || '0'}{' '}
                                                {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {this.state?.bookingData?.wallet_amount_applied > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="">Wallet Amount Applied</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="">
                                                -{this.state?.bookingData?.wallet_amount_applied || '0'}{' '}
                                                {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        {this.state?.bookingData?.extra_payment > 0 && (
                                          <>
                                            <div className="h-line"></div>
                                            <div className="col-8 text-left">
                                              <div className="font-weight-bold light-blue-color">Extra Payment</div>
                                            </div>

                                            <div className="col-4 text-right">
                                              <div className="font-weight-bold">
                                                {this.state?.bookingData?.extra_payment || '0'} {this.state?.currency}
                                              </div>
                                            </div>
                                          </>
                                        )}
                                        <div className="h-line"></div>
                                        <div className="col-8 text-left">
                                          <div className="font-weight-bold light-blue-color">Total Amount</div>
                                        </div>
                                        <div className="col-4 text-right m-b-20">
                                          <div className="font-weight-bold">
                                            {this.state?.bookingData?.total_booking_amount || '0'}{' '}
                                            {this.state?.currency}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>

                                  <div className="dotted-line m-t-20 m-b-20 dark-blue-color">
                                    <div className="right-circle"></div>
                                    <div className="left-circle"></div>
                                  </div>

                                  <div className="row text-center">
                                    <div className="col-12">
                                      <div className="font-weight-bold dark-blue-color">
                                        Booking Pass: {this.state.bookingData?.order_number || '--'}
                                      </div>
                                      <div className="dark-blue-color">
                                        Issue Date:{' '}
                                        {this.state?.bookingData?.payment_details &&
                                        this.state?.bookingData?.payment_details?.length > 0 ? (
                                          <Moment format="DD MMM YYYY">
                                            {this.state?.bookingData?.payment_details[0].created_at}
                                          </Moment>
                                        ) : (
                                          <Moment format="DD MMM YYYY">{this.state?.bookingData?.created_at}</Moment>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <h6>Details not found</h6>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Bookingdetail
